module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/func_report-c11c4509453ba37e3dd32c09f6ca63c9.png";